(function () {
    const body = document.body;
    const navElement = document.getElementById('primary-nav-wrapper');
    if (!navElement) return;

    // Use a sentinel element to detect when the nav should become sticky.
    // This is more performant than scroll events as it uses IntersectionObserver.
    const sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.pointerEvents = 'none';
    sentinel.style.visibility = 'hidden';

    // Insert sentinel right before the navElement
    navElement.parentNode.insertBefore(sentinel, navElement);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {

            // If the sentinel is not intersecting, it means it's above the viewport
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                if (!body.classList.contains('scrolled')) {
                    body.classList.add('scrolled');
                }
            } else {
                if (body.classList.contains('scrolled')) {
                    body.classList.remove('scrolled');
                }
            }
        });
    }, {
        threshold: [0]
    });

    observer.observe(sentinel);
})();
